export namespace ProjectTypesStatic {
  export interface ProjectType {
    id: number;
    name: string;
  }

  export enum ProjectTypeSearchParameters {
    project_type = 'project_type'
  }
}
